import React, { useState, useRef, useEffect, useCallback } from "react";
import ReactDOM from "react-dom";

interface TooltipPortalProps {
  children: React.ReactNode;
  content: React.ReactNode;
}

export const TooltipPortal: React.FC<TooltipPortalProps> = ({ children, content }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const triggerRef = useRef<HTMLDivElement>(null);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const showTooltip = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    setIsVisible(true);
  }, []);

  const hideTooltip = useCallback(() => {
    // 약간의 딜레이를 두고 숨김 (마우스가 툴팁으로 이동할 시간)
    timeoutRef.current = setTimeout(() => {
      setIsVisible(false);
    }, 100);
  }, []);

  useEffect(() => {
    if (isVisible && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      setPosition({
        top: rect.top - 8,
        left: rect.left + rect.width / 2,
      });
    }
  }, [isVisible]);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <>
      <div
        ref={triggerRef}
        onMouseEnter={showTooltip}
        onMouseLeave={hideTooltip}
        className="inline-flex"
      >
        {children}
      </div>
      {isVisible &&
        ReactDOM.createPortal(
          <div
            className="fixed z-[10000] -translate-x-1/2 -translate-y-full"
            style={{ top: position.top, left: position.left }}
            onMouseEnter={showTooltip}
            onMouseLeave={hideTooltip}
          >
            {content}
            <div className="absolute top-full left-1/2 -translate-x-1/2 -mt-1 border-4 border-transparent border-t-[#1F2937]" />
          </div>,
          document.body
        )}
    </>
  );
};
